import { filter, get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectContacts = state => searchEntities(state, 'contacts', ['firstname', 'lastname', 'email']);

export const selectPropertyManagers = state => selectContacts(state).filter(contact => contact.roles[0]&&contact.roles[0].role.name === 'Property Developer');

export const selectStrataManagers = state => selectContacts(state).filter(contact => contact.roles[0]&&contact.roles[0].role.name === 'Strata Manager');

export const selectHomeOwners = state => selectContacts(state).filter(contact => contact.roles.length > 0 ? (contact.roles[0].role.name === 'Home Owner' || contact.roles[0].role.name === 'Occupant' || contact.roles[0].role.name === 'Realtor') : []);

export const selectContactById = (state, id) => selectContacts(state).find(c => c.id === id);

export const selectContactNotes = (state, id) => get(selectContactById(state, id), ['notes'], []);

export const selectContactDocuments = (state, id) => get(selectContactById(state, id), ['documents'], []);

export const selectContactServiceRequests = (state, id) => get(selectContactById(state, id), ['service_requests'], []);

export const selectPropertyAndServiceManagers = state => selectContacts(state).filter(contact => contact.roles.length > 0 ? (contact.roles[0].role.name === 'Property Developer' || contact.roles[0].role.name === 'Service Manager') : []);
